<template>
	<div class="pa-3">
		<v-breadcrumbs :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-card flat class="pb-5">
			<topic-issues-card
				class="mb-3" 
				v-for="(item, index) in listItems.items" 
				:key="index" 
				:item="item"
				@preview="handlePreview">
			</topic-issues-card>

			<div class="text-xs-center pagination-wrapper py-2" v-if="listItems.totalRecords">
				<v-pagination v-model="listItems.page" :length="listItems.maxPage" :total-visible="7" @input="handlePageChanged(listItems.page)"></v-pagination>
			</div>

			<v-alert :value="!listItems.items.length" type="info" class="white--text">No more incoming reports.</v-alert>
		</v-card>

		<content-preview  :content-keys="previewKeys" @close="closePreview"></content-preview>
	</div>
</template>

<script>
	import * as config from '@/config'
	import * as types from '@/stores/mutation-types'

	import TopicIssuesCard from '@/views/cloud/automated-tagging/Card.vue'
	import ContentPreview from '@/components/ContentPreview.vue'

	export default {
		components: {
			TopicIssuesCard,
			ContentPreview
		},
		data () {
			return {
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: `${config.PUBLIC_PATH}`
					},
					{
						text: 'Cloud',
						disabled: true,
						href: `${config.PUBLIC_PATH}cloud`
					},
					{
						text: 'Automated Tagging',
						disabled: true,
						href: `${config.PUBLIC_PATH}cloud/automated-tagging`
					}					
				],
				pageSize: 10,
				loading: true,
				listItems: {
					page: 1,
					maxPage: 1,
					totalRecords: 0,
					items: []
				},
				previewKeys: null,
			}
		},
		methods: {
			scrollToTop () {
				window.scrollTo({ top: 0, behavior: 'smooth' })
			},
			handlePageChanged (page)
			{
				let url = `${config.BASE_URL}/topic`
				let params = { page: page, limit: this.pageSize }

				this.scrollToTop()

				axios.get( url, { params: params })
					.then((response) => {
						if (response.data.code == 0) {
							if (response.data.data.totalRecords > 0) {
								this.listItems = {
									page: response.data.data.page,
									maxPage: this.listItems.maxPage,
									totalRecords: response.data.data.totalRecords,
									items: response.data.data.topicList
								}
								if (response.data.data.totalRecords == this.pageSize) {
									this.listItems.maxPage = (this.listItems.page >= this.listItems.maxPage) ? (this.listItems.page + 1) : this.listItems.maxPage
								} else if (response.data.data.totalRecords > 0) {
									this.listItems.maxPage = this.listItems.page
								} else {
									this.listItems.maxPage = 1
									this.handlePageChanged(page - 1)
								}
							} else {
								this.listItems = {
									page: 1,
									maxPage: 1,
									totalRecords: 0,
									items: []
								}
							}
						}
					})
			},
			closePreview ()
			{
				this.previewKeys = null
			},
			handlePreview (keys) 
			{
				this.previewKeys = keys
			}
		},
		mounted () {
			this.handlePageChanged(1)
		}
	}
</script>

<style lang="scss">
	.pagination-wrapper {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 100%;
		background: rgba(255, 255, 255, .8);
		box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
		z-index: 1;
	}
</style>